import { useDeleteDocumentMutation } from "@common/api/documents"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/documents/_list/delete/$documentId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "document:delete", "/"),
  component: DeleteDocumentDialog,
})

function DeleteDocumentDialog(): React.ReactElement {
  const { documentId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteDocumentMutation()

  const close = () => navigate({ to: "/documents", search: true })

  return (
    <DeleteDialog
      noun="document"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { document_id: documentId },
          {
            onSuccess: () => {
              showToast("Deleted", "Document deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
